export default {
  'exception-404.exception.back': 'Back to home',
  'exception-404.description.404': 'Sorry, the page you visited does not exist',
};
